import { Options, serialize } from 'object-to-formdata'

const baseOptions = { allowEmptyArrays: true, booleansAsIntegers: true }
export const toFormData = (obj: object, options: Options = {}): FormData => {
  return serialize(obj, { ...baseOptions, ...options })
}
